import React from 'react';
import { Link } from 'react-router-dom';
import {
    FaInstagram,
    FaLinkedinIn
} from 'react-icons/fa';
import Logo from '../../assets/logo.png' 
import { useContentful } from '../contentful-context';
import { getImageUrl } from '../utils';

function Footer() {
  const content = useContentful();

  if (!content.footer.length || !content.images.length) {
    return null;
  }

  const construxLogoWhite = getImageUrl(content.images.find(image => image.id === "Construx-White-FullColor-Tag"));

  const openLink = (url) => {
    window.open(url, '_blank');
  }

  return (
    <footer className='bg-warm-900 text-white font-bai'>
      {/* Main Footer Content - Single Row */}
      <div className='max-w-6xl mx-auto px-6 md:px-10 py-8'>
        <div className='flex flex-col md:flex-row items-center justify-between gap-6'>
          
          {/* Brand & Tagline */}
          <div className='flex flex-col md:flex-row items-center gap-4 md:gap-6'>
            <Link to='/'>
              <img src={construxLogoWhite} alt='construx logo' className='w-36 md:w-40' />
            </Link>
            <p className='text-gray-400 text-sm text-center md:text-left max-w-md'>
              Construction reimagined. Better, faster, stronger homes through digital manufacturing technology.
            </p>
          </div>
          
          {/* Social Icons & Email */}
          <div className='flex flex-col items-center gap-3'>
            <div className='flex gap-3'>
              <button 
                onClick={() => openLink('https://www.instagram.com/buildconstrux/')}
                className='w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-construx-red transition-colors duration-300'
                aria-label='Instagram'
              >
                <FaInstagram size={18} />
              </button>
              <button 
                onClick={() => openLink('https://www.linkedin.com/company/buildconstrux')}
                className='w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-construx-red transition-colors duration-300'
                aria-label='LinkedIn'
              >
                <FaLinkedinIn size={18} />
              </button>
            </div>
            <a 
              href='mailto:hello@buildconstrux.com'
              className='text-gray-400 text-sm hover:text-white transition-colors duration-300'
            >
              hello@buildconstrux.com
            </a>
          </div>
        </div>
      </div>
      
      {/* Bottom Bar */}
      <div className='border-t border-white/10'>
        <div className='max-w-6xl mx-auto px-6 md:px-10 py-4'>
          <div className='flex flex-col md:flex-row items-center justify-between gap-2'>
            <p className='text-gray-500 text-xs'>
              © {new Date().getFullYear()} Build with Construx Inc, DBA Construx. All rights reserved.
            </p>
            <div className='flex items-center gap-4'>
              <Link to='/privacy' className='text-gray-500 text-xs hover:text-white transition-colors duration-300'>
                Privacy Policy
              </Link>
              <Link to='/terms' className='text-gray-500 text-xs hover:text-white transition-colors duration-300'>
                Terms of Service
              </Link>
            </div>
            <p className='text-gray-500 text-xs'>
              Better · Faster · Stronger
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
